import React from "react";
import Testimonials from "../home/Testimonials";

const ComparisonTestimonials = () => {
  return <Testimonials />;
};

export default ComparisonTestimonials;
